<div class="purchase-container">
  <div class="breadcrumb-header">
    <div class="breadcrumb">
      <span class="text-muted" routerLink="/company-admin/billing-payments">{{ 'dash.billingTitle' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span class="text-muted">{{ 'dash.virtualInterview' | translate }}</span>
      <i class="bi bi-chevron-right mx-2 text-muted" style="font-size: 12px;"></i>
      <span>{{ 'dash.purchaseBreadcrumb' | translate }}</span>
    </div>
    <button class="btn-back" routerLink="/company-admin/billing-service-details">
      <i class="bi bi-arrow-left"></i> {{ 'dash.back' | translate }}
    </button>
  </div>

  <div class="page-title">
    <h1>{{ 'dash.chooseViPackage' | translate }}</h1>
    <p class="subtitle">{{ 'dash.choosePackageStart' | translate }}</p>
  </div>

  <div class="purchase-box">
    <div class="info-message">
      <i class="bi bi-info-circle"></i>
      <h3>{{ 'dash.packagesNotPublished' | translate }}</h3>
      <p>{{ 'dash.packagesComing' | translate }}</p>
    </div>

    <div class="pricing-cards">
      <!-- Starter Plan -->
      <div class="pricing-card">
        <h4>{{ 'dash.starter' | translate }}</h4>
        <div class="price">
          <span class="currency">$</span><span class="amount">0</span>
        </div>
        <div class="billing-cycle">{{ 'dash.userMo' | translate }}</div>
        <div class="divider"></div>
        <div class="feature-interviews">{{ 'dash.interviewsCount' | translate:{ count: 50 } }}</div>
        <button class="btn-outline-red">{{ 'dash.selectPlan' | translate }}</button>
        <div class="feature-skills">{{ 'dash.interviewSkills' | translate:{ count: 5 } }}</div>
      </div>

      <!-- Growth Plan -->
      <div class="pricing-card">
        <h4>{{ 'dash.growth' | translate }}</h4>
        <div class="price">
          <span class="currency">$</span><span class="amount">0</span>
        </div>
        <div class="billing-cycle">{{ 'dash.userMo' | translate }}</div>
        <div class="divider"></div>
        <div class="feature-interviews">{{ 'dash.interviewsCount' | translate:{ count: 150 } }}</div>
        <button class="btn-outline-red">{{ 'dash.selectPlan' | translate }}</button>
        <div class="feature-skills">{{ 'dash.interviewSkills' | translate:{ count: 5 } }}</div>
      </div>

      <!-- Business Plan -->
      <div class="pricing-card">
        <h4>{{ 'dash.business' | translate }}</h4>
        <div class="price">
          <span class="currency">$</span><span class="amount">15</span>
        </div>
        <div class="billing-cycle">{{ 'dash.userMo' | translate }}</div>
        <div class="divider"></div>
        <div class="feature-interviews">{{ 'dash.interviewsCount' | translate:{ count: 250 } }}</div>
        <button class="btn-red-gradient">{{ 'dash.selectPlan' | translate }}</button>
        <div class="feature-skills">{{ 'dash.interviewSkills' | translate:{ count: 10 } }}</div>
      </div>

      <!-- Professional Plan -->
      <div class="pricing-card popular">
        <div class="ribbon">{{ 'dash.popularPlan' | translate }}</div>
        <h4>{{ 'dash.professional' | translate }}</h4>
        <div class="price">
          <span class="currency">$</span><span class="amount">35</span>
        </div>
        <div class="billing-cycle">{{ 'dash.userMo' | translate }}</div>
        <div class="divider"></div>
        <div class="feature-interviews">{{ 'dash.interviewsCount' | translate:{ count: 350 } }}</div>
        <button class="btn-red-gradient">{{ 'dash.selectPlan' | translate }}</button>
        <div class="feature-skills">{{ 'dash.interviewSkills' | translate:{ count: 12 } }}</div>
      </div>

      <!-- Enterprise Plan -->
      <div class="pricing-card">
        <h4>{{ 'dash.enterprise' | translate }}</h4>
        <div class="price">
          <span class="currency">$</span><span class="amount">15</span>
        </div>
        <div class="billing-cycle">{{ 'dash.userMo' | translate }}</div>
        <div class="divider"></div>
        <div class="feature-interviews">{{ 'dash.interviewsCount' | translate:{ count: 500 } }}</div>
        <button class="btn-outline-red">{{ 'dash.selectPlan' | translate }}</button>
        <div class="feature-skills">{{ 'dash.interviewSkills' | translate:{ count: 15 } }}</div>
      </div>
    </div>
  </div>
  
  <div class="footer-actions">
    <button class="btn-outline-gray" routerLink="/company-admin/billing-payments">{{ 'dash.backToBilling' | translate }}</button>
  </div>
</div>
